import React, { Component } from 'react';
import * as contentful from 'contentful';
import brandUtil from '../../../../../js_source/com/utils/brand';

class PlpSeoContainer extends Component {
	state = {
		loading: true,
		dataLoaded: false,
		plpSeoCopy: null
	};

	config = {
		brandTag: brandUtil
			.content(brandUtil.getBrand())
			.tag.replace('wpe', 'wp')
			.replace('vir', 'virgin'),
		country: brandUtil.getCountry()
	};

	client = contentful.createClient({
		space: '759ah7skns84',
		accessToken: 'xYnUnlTFJ_jR4HayH_3GydjYLml3QREEBvki4HxGB3Y'
	});

	componentDidMount() {
		setTimeout(() => {
			if (JSON.parse(sessionStorage.getItem('plpSeoCopy'))) {
				this.setState({
					loading: false,
					plpSeoCopy: JSON.parse(sessionStorage.getItem('plpSeoCopy'))
				});
			} else {
				this.fetchData();
			}
		}, 3000);

		setTimeout(() => {
			sessionStorage.removeItem('plpSeoCopy');
		}, 6000);
	}

	fetchData = () => {
		const plpGrapeCopy = this.client.getEntries({
				content_type: 'plpVarietyCopySeo'
			}),
			plpRegionCopy = this.client.getEntries({
				content_type: 'plpRegionCopySeo'
			});

		Promise.all([plpGrapeCopy, plpRegionCopy]).then((responses) => {
			this.processData(responses);
		});
	};

	processData = (response) => {
		let plpSeoCopy = null,
			brand = this.config.country + '-' + this.config.brandTag,
			match = location.href;

		if (response.length > 0) {
			response.forEach(function(each) {
				if (each.items.length > 0) {
					each.items.forEach(function(item) {
						if (item.hasOwnProperty('fields') && item.fields.brand === brand) {
							if (
								item.fields.hasOwnProperty('title') &&
								match.indexOf(
									item.fields.title
										.trim()
										.split(' ')
										.join('-')
								) > -1
							) {
								plpSeoCopy = item.fields;
							}
						}
					});
				}
			});
		}

		this.setState({
			loading: false,
			plpSeoCopy: plpSeoCopy
		});
	};

	render() {
		let topCopy = '';

		if (!this.state.loading && this.state.plpSeoCopy) {
			topCopy = (
				<div
					className='search__seo-copy bottom'
					dangerouslySetInnerHTML={{ __html: this.state.plpSeoCopy.longCopy }}
				></div>
			);
		}

		return topCopy;
	}
}

export default PlpSeoContainer;
